module.exports = {"properties":{"beforeRequest":{"$ref":"#cacheEntry"},"afterRequest":{"$ref":"#cacheEntry"},"comment":{"type":"string"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/har-validator/lib/schemas/cache.json
// module id = xhB5
// module chunks = 14